export default "__VITE_ASSET__Qjje6Iox__"